// extracted by mini-css-extract-plugin
module.exports = {"Header":"Thread_Header__3w5uI"};